var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.5,
    width: 29,
    height: 29,
    rx: 13.5,
    fill: "#EB5757",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9535_23887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4406 14.058L20.3226 16.354C20.8136 16.644 20.8136 17.355 20.3226 17.645L16.4406 19.941C15.9406 20.237 15.3086 19.876 15.3086 19.295V14.704C15.3086 14.123 15.9406 13.762 16.4406 14.058Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9535_23887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5.5 5)"
  })))));
};
export { SvgPlayIcon as ReactComponent };
export default __webpack_public_path__ + "play-icon.svg";